import React from 'react';
import AuthScreen from '../components/auth/AuthScreen';

/** `/login` — the auth screen in its login state (components/auth/AuthScreen). */
export default function LoginPage() {
  return <AuthScreen screen="login" />;
}
